import { useFetchFrontendCategoriesQuery } from "../../stores/api/pages.api";
import { UserLayout } from "./components/layout/UserLayout";
import PageHero from "./components/PageHero";
import Container from "./components/Container";
import Text from "./components/Text";
import Img from "./components/Img";
import { getImg } from "../../Components/Utils";
import { ROUTE_PATHS } from "../../constants/routeConstants";

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const AllCategoriesSkeleton = () => (
  <UserLayout>
    <Container variant="narrow" className="py-10 px-4 lg:px-8">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="h-48" />
        ))}
      </div>
    </Container>
  </UserLayout>
);

const AllCategories = () => {
  const { data: categories, isLoading } = useFetchFrontendCategoriesQuery();

  if (isLoading) return <AllCategoriesSkeleton />;

  return (
    <UserLayout>
      <PageHero
        title="Categories"
        crumbs={[
          { label: "Home", href: ROUTE_PATHS.HOME },
          { label: "Categories" },
        ]}
      />

      <Container variant="narrow" className="py-10 px-4 lg:px-8">
        <Container
          variant="full"
          showEmptyState={!categories?.length}
          emptyMessage="No categories found."
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {(categories ?? []).map((cat) => (
              <Text
                key={cat.slug}
                is="a"
                href={ROUTE_PATHS.CATEGORY_DETAIL.replace(":categorySlug", cat.slug)}
                className="group block border border-gray-200 rounded-lg overflow-hidden hover:border-gray-900 transition-colors"
              >
                <div className="aspect-square overflow-hidden bg-gray-50">
                  <Img
                    src={getImg(cat.image)}
                    alt={cat.image_alt || cat.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="px-4 py-3 text-center text-sm font-medium text-gray-700 group-hover:text-gray-900 transition-colors">
                  {cat.name}
                </div>
              </Text>
            ))}
          </div>
        </Container>
      </Container>
    </UserLayout>
  );
};

export default AllCategories;
